import { FC } from "react";
import { formatCurrency } from "@dashboard/utils/format-currency";
import { PlatformCountry } from "@dashboard/common/types";
import { DeliveryProviderQuote } from "../../entities/delivery.entities";
import { DeliveryProviderSelectorWrapper } from "./delivery-provider-selector.styled";

type DeliveryProviderSelectorProps = {
  providers: DeliveryProviderQuote[];
  selectedProviderId: string;
  onSelect: (quote: DeliveryProviderQuote) => void;
  userCountry?: PlatformCountry;
};

const shouldShowDescriptionTime = (text?: string): boolean => {
  const trimmed = text?.trim();
  if (!trimmed) return false;
  return !trimmed.toLowerCase().startsWith("description_time");
};

export const DeliveryProviderSelector: FC<DeliveryProviderSelectorProps> = ({
  providers,
  selectedProviderId,
  onSelect,
  userCountry,
}) => {
  if (!providers.length) {
    return null;
  }

  return (
    <DeliveryProviderSelectorWrapper>
      {providers.map((quote) => {
        const { provider, total } = quote;
        const isSelected = provider.id === selectedProviderId;
        const descriptionTime = shouldShowDescriptionTime(
          provider.descriptionTime
        )
          ? provider.descriptionTime?.trim()
          : undefined;

        return (
          <label
            key={provider.id}
            className={`provider-item${isSelected ? " selected" : ""}`}
          >
            <div className="provider-radio">
              <input
                type="radio"
                name="delivery-provider"
                checked={isSelected}
                onChange={() => onSelect(quote)}
              />
            </div>
            <div className="provider-body">
              {provider.icon && (
                <img
                  className="provider-icon"
                  src={provider.icon}
                  alt={provider.name || ""}
                />
              )}
              <div className="provider-details">
                <span className="provider-name">{provider.name}</span>
                {descriptionTime && (
                  <span className="provider-time">{descriptionTime}</span>
                )}
              </div>
              <span className="provider-price">
                {formatCurrency(total, userCountry)}
              </span>
            </div>
          </label>
        );
      })}
    </DeliveryProviderSelectorWrapper>
  );
};
